export const DisplayMode = {
  LIST: 'LIST',
  DETAIL: 'DETAIL',
} as const
export type DisplayModeType = (typeof DisplayMode)[keyof typeof DisplayMode]
